import { faChevronDown } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PortalDataGridPro from '../../common/PortalDataGridPro';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Stack,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { getFutureMeetingsColumns, getColumns } from './columns';
import { getMeetingMenu } from './meetingMenu';

export default function Meetings({
  id,
  title,
  meetings = [],
  isPastMeetings = false,
  codecs,
  onDelete,
  onStart,
  onEnableGuestSpeaker,
  onAddAlternativeHost,
  onEnableJoinBeforeHost,
  onCopyMeetingInvitation,
  onDeleteCalendarEntry,
  onCreateCalendarEntry,
  onAddCodecs,
  onRemoveCodecs,
}) {
  const [isExpand, setIsExpand] = useState(isPastMeetings ? false : true);

  const toggleIsExpand = () => {
    setIsExpand((prev) => !prev);
  };

  return (
    <>
      <Accordion
        elevation={0}
        expanded={isExpand}
        id={id + '__accordion'}
        className={'myOdu__accordion myOdu__border p-2'}
        sx={{
          width: '100%',
          p: 0,
          m: 0,
        }}
      >
        <AccordionSummary
          expandIcon={
            <FontAwesomeIcon id={id + '__icon_chevronDown'} icon={faChevronDown} size="lg" />
          }
          id={id + '__accordionSummary'}
          aria-controls={id + '__accordionDetails'}
          sx={{
            m: 0,
            p: 0,
            flexDirection: 'row-reverse',
            flexGrow: 1,
          }}
          onClick={toggleIsExpand}
        >
          <Stack id={id + '__stack_titleWrapper'} direction="row" sx={{ ml: 0.5 }}>
            <Typography id={id + '__text_title'} variant="h6" component="h4">
              {title}
            </Typography>
          </Stack>
        </AccordionSummary>
        <AccordionDetails
          //NOTE: when the AccordionSummary is provided with a aria-control it automatically makes
          // an id for the AccordionDetails with that ID
          // So this LOC is not needed:
          // id={ id + '__accordionDetails' }
          sx={{}}
        >
          <PortalDataGridPro
            className="myOdu__resultTable inner"
            rows={meetings}
            id={`${id}__dataGrid`}
            columns={
              isPastMeetings
                ? getColumns({ id, codecs })
                : getFutureMeetingsColumns({
                    id,
                    onStart,
                    isPastMeetings,
                    onDelete: onDelete,
                    meetingMenu: getMeetingMenu({
                      enableGuest: onEnableGuestSpeaker,
                      addAlternativeHost: onAddAlternativeHost,
                      enableJoinBeforeHost: onEnableJoinBeforeHost,
                      copyMeetingInvitation: onCopyMeetingInvitation,
                      deleteCalendarEntry: onDeleteCalendarEntry,
                      createCalendarEntry: onCreateCalendarEntry,
                      addCodecs: onAddCodecs,
                      removeCodecs: onRemoveCodecs,
                    }),
                    codecs,
                  })
            }
            sx={{
              '& .MuiDataGrid-cell--pinnedLeft': {
                zIndex: '10 !important',
              },
              '& .MuiDataGrid-cell': {
                whiteSpace: 'nowrap !important',
                minHeight: '3rem',
                alignContent: 'center',
              },
            }}
            getRowId={(row) => row.id}
            autoHeight
            initialState={{
              pagination: {
                paginationModel: { pageSize: 10 },
              },
            }}
            pagination
            getRowHeight={(params) => {
              return 'auto';
            }}
            disableRowSelectionOnClick
            slots={{
              noRowsOverlay: () => {
                return (
                  <Box
                    mt={1}
                    display="flex"
                    justifyContent="center"
                    id={`${id}__box_noResultsWrapper`}
                  >
                    <Typography
                      variant="p"
                      component="p"
                      style={{ margin: 4 }}
                      id={`${id}__p_noResults`}
                    >
                      {`There are no ${isPastMeetings ? 'past ' : ''} meetings found.`}
                    </Typography>
                  </Box>
                );
              },
            }}
          />
        </AccordionDetails>
      </Accordion>
    </>
  );
}
